/**
 * Política de senhas, compartilhada entre a tela (feedback imediato) e a API
 * (que é quem realmente decide). Regras simples e eficazes:
 * comprimento importa mais que símbolos obrigatórios.
 */

export const SENHA_MIN = 10;
export const SENHA_MAX = 128;

export function validarSenha(senha: string, email?: string): string[] {
  const erros: string[] = [];
  if (senha.length < SENHA_MIN) erros.push(`Use pelo menos ${SENHA_MIN} caracteres.`);
  if (senha.length > SENHA_MAX) erros.push(`Use no máximo ${SENHA_MAX} caracteres.`);
  if (!/[A-Za-zÀ-ÿ]/.test(senha)) erros.push('Inclua pelo menos uma letra.');
  if (!/\d/.test(senha)) erros.push('Inclua pelo menos um número.');

  const local = email?.split('@')[0]?.toLowerCase();
  if (local && local.length >= 4 && senha.toLowerCase().includes(local)) {
    erros.push('A senha não pode conter o seu e-mail.');
  }
  return erros;
}
